import { gql } from 'graphql-tag';

export const GET_EXPENSE_ACCOUNT = gql`
  query Id5986e577418b763f3b6f488484b56567(
    $companyId: ID!
    $filter: ExpenseAccountFilter
  ) {
    __typename
  }
`;
